// extracted by mini-css-extract-plugin
export default {"container":"AlertsDetails_container__-bxOb","items_overflow_container":"AlertsDetails_items_overflow_container__iAUtr"};